/**
 * Banners de "últimas funcionalidades" en el panel The Vault del mega menú.
 *
 * Consume cards.the-vault.mx/api/updates/latest (top 3 de lib/updates.ts en
 * CardVault, cacheado 10 min en edge). Si el endpoint no responde, el bloque
 * queda oculto y el panel conserva solo el promo estático — degradación limpia.
 *
 * Construye nodos DOM (nada de innerHTML con datos remotos).
 */
(function () {
  'use strict';

  var ENDPOINT = 'https://cards.the-vault.mx/api/updates/latest';

  function el(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text) node.textContent = text;
    return node;
  }

  function render(mount, updates) {
    var heading = el('p', 'mega-menu__aside-heading', 'Lo nuevo en The Vault');
    mount.appendChild(heading);

    // 3 temas de color de la familia de las landings de funcionalidad,
    // barajados al azar en cada carga (sin repetir).
    var themes = ['amber', 'violet', 'orange'].sort(function () {
      return Math.random() - 0.5;
    });

    var row = el('span', 'mega-menu__updates-row');
    updates.slice(0, 3).forEach(function (update, index) {
      var card = el('a', 'mega-menu__update mega-menu__update--' + themes[index % themes.length]);
      var href = String(update.link || 'https://cards.the-vault.mx/updates');
      if (href.indexOf('https://') !== 0 && href.indexOf('/') !== 0) return;
      card.href = href;

      var hero = el('span', 'mega-menu__update-hero');
      hero.appendChild(el('span', 'mega-menu__update-emoji', String(update.emoji || '📰')));
      // Nombre propio de la funcionalidad; el endpoint cae al área si es una
      // mejora sin nombre. Si no viene ninguno, solo va el emoji.
      if (update.feature) {
        hero.appendChild(el('span', 'mega-menu__update-feature', String(update.feature)));
      }
      card.appendChild(hero);
      var body = el('span', 'mega-menu__update-body');
      body.appendChild(el('span', 'mega-menu__update-title', String(update.title || '')));
      if (update.summary) {
        body.appendChild(el('span', 'mega-menu__update-summary', String(update.summary)));
      }
      card.appendChild(body);
      row.appendChild(card);
    });
    mount.appendChild(row);

    mount.hidden = false;
  }

  function init() {
    var mount = document.querySelector('[data-vault-updates]');
    if (!mount) return;

    fetch(ENDPOINT)
      .then(function (response) {
        if (!response.ok) throw new Error('HTTP ' + response.status);
        return response.json();
      })
      .then(function (data) {
        var updates = (data && data.updates) || [];
        if (updates.length > 0) render(mount, updates);
      })
      .catch(function () {
        /* sin red o endpoint caído: el panel se queda como está */
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
